import logoColor from "@/assets/logo.png";
import logoWhite160 from "@/assets/logo-header-white-160.webp";
import logoWhite320 from "@/assets/logo-header-white-320.webp";
import { LOGO_HEADER_INTRINSIC, logoHeaderImgBaseClass } from "@/lib/logoHeaderImage";
import { cn } from "@/lib/utils";

/** Matches MarketingHeader / MarketingFooter logo slot (max ~140px mobile, ~160px sm+). */
export const LOGO_HEADER_SIZES_BAR = "(max-width: 639px) 140px, 160px";

/** Larger logo (auth, onboarding wizard). */
export const LOGO_HEADER_SIZES_LARGE = "(max-width: 640px) min(92vw, 320px), 320px";

/** Compact app headers (PFA / caterer / admin). */
export const LOGO_HEADER_SIZES_APP_HEADER = "(max-width: 767px) 100px, 130px";

/** Display class for in-app chrome (dashboard headers). Keep shorter than nav pills. */
export const LOGO_HEADER_APP_CLASS = "max-h-5 md:max-h-6";

type Props = {
  className?: string;
  /** Responsive slot width (used only for the white variant srcset). */
  sizes?: string;
  /** `white` = full-white mark for dark / colored backgrounds. */
  variant?: "color" | "white";
};

/**
 * Kryajet wordmark. Color variant uses the source PNG (1024×131) so the browser
 * scales down — no generated 160/320 crops. White still uses existing WebP until a source is provided.
 */
export function LogoHeaderImage({
  className,
  sizes = LOGO_HEADER_SIZES_BAR,
  variant = "color",
}: Props) {
  if (variant === "white") {
    return (
      <img
        src={logoWhite320}
        srcSet={`${logoWhite160} 160w, ${logoWhite320} 320w`}
        sizes={sizes}
        alt="Kryajet"
        width={LOGO_HEADER_INTRINSIC.width}
        height={LOGO_HEADER_INTRINSIC.height}
        decoding="async"
        className={cn(logoHeaderImgBaseClass, className)}
      />
    );
  }

  return (
    <img
      src={logoColor}
      alt="Kryajet"
      width={LOGO_HEADER_INTRINSIC.width}
      height={LOGO_HEADER_INTRINSIC.height}
      decoding="async"
      className={cn(logoHeaderImgBaseClass, className)}
    />
  );
}
